// Taxi marker - Simple and visible taxi icon
// Body color changes based on driver status

export const getCarMarkerSvg = (status, rotation = 0) => {
  // Main body color based on status
  let mainColor, darkColor, lightColor;
  
  switch (status) {
    case 'online':
      mainColor = '#22c55e';  // Green
      darkColor = '#166534';
      lightColor = '#86efac';
      break;
    case 'busy':
    case 'on_trip':
      mainColor = '#fabc0c';  // Yellow (brand color)
      darkColor = '#d4a00a';
      lightColor = '#fcd34d';
      break;
    case 'offline':
    default:
      mainColor = '#9ca3af';  // Gray
      darkColor = '#6b7280';
      lightColor = '#d1d5db';
      break;
  }

  // Simple, visible taxi marker SVG
  const carSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  <!-- Shadow -->
  <ellipse cx="24" cy="44" rx="12" ry="3" fill="rgba(0,0,0,0.2)"/>
  
  <!-- Taxi body -->
  <rect x="8" y="18" width="32" height="20" rx="4" fill="${mainColor}" stroke="${darkColor}" stroke-width="2"/>
  
  <!-- Roof/top -->
  <rect x="14" y="8" width="20" height="12" rx="3" fill="${mainColor}" stroke="${darkColor}" stroke-width="2"/>
  
  <!-- Windshield -->
  <rect x="16" y="10" width="16" height="8" rx="2" fill="#1e3a5f"/>
  
  <!-- Windows -->
  <rect x="10" y="20" width="10" height="6" rx="1" fill="#1e3a5f"/>
  <rect x="28" y="20" width="10" height="6" rx="1" fill="#1e3a5f"/>
  
  <!-- Wheels -->
  <circle cx="14" cy="38" r="5" fill="#333"/>
  <circle cx="14" cy="38" r="2.5" fill="#666"/>
  <circle cx="34" cy="38" r="5" fill="#333"/>
  <circle cx="34" cy="38" r="2.5" fill="#666"/>
  
  <!-- Taxi sign -->
  <rect x="18" y="4" width="12" height="5" rx="2" fill="#fabc0c" stroke="#d4a00a" stroke-width="1"/>
  <text x="24" y="8" font-size="4" font-weight="bold" fill="#000" text-anchor="middle">TAXI</text>
  
  <!-- Headlights -->
  <circle cx="11" cy="32" r="2" fill="${lightColor}"/>
  <circle cx="37" cy="32" r="2" fill="${lightColor}"/>
</svg>
`;

  return `data:image/svg+xml,${encodeURIComponent(carSvg.trim())}`;
};

export const getCarMarkerIcon = (status, rotation = 0) => {
  const size = window.google && window.google.maps 
    ? new window.google.maps.Size(48, 48) 
    : { width: 48, height: 48 };
  const anchor = window.google && window.google.maps
    ? new window.google.maps.Point(24, 44)
    : { x: 24, y: 44 };
    
  return {
    url: getCarMarkerSvg(status, rotation),
    scaledSize: size,
    anchor: anchor
  };
};

// Pin marker for pickup/dropoff
export const getLocationPinSvg = (type = 'pickup') => {
  const color = type === 'pickup' ? '#dc2626' : '#059669';
  
  const pinSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
      <ellipse cx="16" cy="38" rx="6" ry="2" fill="rgba(0,0,0,0.2)"/>
      <path d="M16 0C7.163 0 0 7.163 0 16c0 12 16 24 16 24s16-12 16-24C32 7.163 24.837 0 16 0z" fill="${color}"/>
      <circle cx="16" cy="14" r="6" fill="white"/>
      <circle cx="16" cy="14" r="2" fill="${color}"/>
    </svg>
  `;

  return `data:image/svg+xml,${encodeURIComponent(pinSvg.trim())}`;
};

export const getLocationPinIcon = (type = 'pickup') => {
  const size = window.google && window.google.maps
    ? new window.google.maps.Size(28, 35)
    : { width: 28, height: 35 };
  const anchor = window.google && window.google.maps
    ? new window.google.maps.Point(14, 35)
    : { x: 14, y: 35 };
    
  return {
    url: getLocationPinSvg(type),
    scaledSize: size,
    anchor: anchor
  };
};

export const CAR_STATUS_COLORS = {
  online: '#22c55e',
  busy: '#fabc0c',
  on_trip: '#fabc0c',
  offline: '#9ca3af',
  break: '#f97316'
};
